import { useRef, useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import CaptchaField, { type CaptchaFieldHandle } from '@/components/CaptchaField';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef<CaptchaFieldHandle>(null);
  const [form] = Form.useForm<{ email: string; password: string; captchaAnswer: string }>();

  const onFinish = async (values: { email: string; password: string; captchaAnswer: string }) => {
    const captchaId = captchaRef.current?.getId();
    if (!captchaId) {
      message.error('请等待验证码加载');
      return;
    }
    setLoading(true);
    try {
      await login(values.email, values.password, captchaId, values.captchaAnswer);
      navigate('/home');
    } catch (e) {
      message.error(e instanceof Error ? e.message : '登录失败');
      // 服务端已消费旧验证码, 必须换一张
      captchaRef.current?.refresh();
      form.setFieldsValue({ captchaAnswer: '' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-hero">
      <div className="auth-hero__card">
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div className="brand-logo" style={{ fontSize: 26 }}>予人智图</div>
          <Typography.Text type="secondary">创作者平台 · 让每一张图都被精心对待</Typography.Text>
        </div>
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="on">
          <Form.Item
            name="email"
            label="邮箱"
            rules={[{ required: true, message: '请输入邮箱' }, { type: 'email', message: '邮箱格式不对' }]}
          >
            <Input placeholder="creator@example.com" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }, { min: 8, message: '至少 8 位' }]}
          >
            <Input.Password size="large" />
          </Form.Item>
          <CaptchaField ref={captchaRef} />
          <Button type="primary" htmlType="submit" loading={loading} block size="large">
            登录
          </Button>
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Typography.Text type="secondary">还没账号？</Typography.Text>{' '}
            <Link to="/register">立即注册</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
